/**
 * Emails exempt from the forced-MFA enrollment gate.
 *
 * Service / automation accounts log into the command-center headlessly (e.g. the
 * agent-browser test runs) and cannot complete an interactive TOTP enrollment, so
 * they must be allowed through at aal1 instead of being blocked behind the gate.
 *
 * SECURITY NOTE: exempt accounts run at aal1 and therefore STILL cannot mint prod
 * access tokens — minting requires aal2 server-side (mfaProtectedProcedure). The
 * exemption only avoids blocking general app access; it does not weaken token auth.
 */
export const MFA_EXEMPT_EMAILS = [
  "agent-test@aixlabs.co", // automated browser testing (agent-browser)
]

export const isMfaExempt = (email?: string | null): boolean =>
  !!email && MFA_EXEMPT_EMAILS.includes(email.toLowerCase())
